import { render, staticRenderFns } from "./Outer.vue?vue&type=template&id=6d3c2cf0&"
import script from "./Outer.vue?vue&type=script&lang=js&"
export * from "./Outer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports